import * as React from 'react'
import * as API from '../lib/api'
import { HashFields, HiddenField } from 'react-rails-form-helpers'

interface IProps {
  dataDescriptor: string
  dataValue: string
  creditCard: API.ICreditCard
}

export class PaymentTokenForm extends React.Component<IProps, object> {
  public render() {
    const {
      dataDescriptor,
      dataValue,
      creditCard,
    } = this.props

    return (
      <>
        <HashFields name={'accept_js_token'}>
          <HiddenField name="data_descriptor" value={dataDescriptor} />
          <HiddenField name="data_value" value={dataValue} />
          <HiddenField name="card_number" value={this.maskCard(creditCard.card_number)} />
          <HiddenField name="exp_month" value={creditCard.exp_month}/>
          <HiddenField name="exp_year" value={creditCard.exp_year}/>
        </HashFields>
          <HiddenField name="payment_type" value="accept_js_token" />
      </>
    )
  }
    protected maskCard(cardNumber) {
      const firstSix = cardNumber.substring(0, 6)
      const lastFour = cardNumber.slice(-4)
      return `${firstSix}X${lastFour}`
    }
}
